var map = {
	"./son1_active.png": "4af8",
	"./son2_active.png": "1a33",
	"./son3_active.png": "5f50",
	"./son4_active.png": "2376",
	"./son5_active.png": "0b04",
	"./son6_active.png": "bdd6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f985";